import alt from '../alt';
import generateWithAsyncActions from 'epic-alt-utils/index';

export default generateWithAsyncActions(alt, [], [
    'searchActive',
    'mobileNavActive',
    'mobileActiveLinkIndex',
    'tabletNavActive',
    'mobileLocaleActive',
    'mobileUserActive',
    'mobileNavActiveLinks',
    'closeMobileTablet',
    'euCookieMessageClose',
    'setEuCookieAccepted',
    'CTAclick'
]);
